export default "__VITE_ASSET__BupvMEyk__"